import React from "react";
import { PageHeader } from "@/components/Bits";

export default function Disclaimer() {
  return (
    <div>
      <PageHeader title="Disclaimer & Risk Warning" subtitle="Ostrzeżenie o ryzyku i regulamin" />
      <div className="glow-card rounded-2xl p-6 sm:p-8 space-y-5 text-sm leading-relaxed text-demon-muted max-w-3xl">
        <p className="text-white font-semibold text-base">1. Charakter edukacyjny</p>
        <p>
          Wszystkie materiały, dane, kalkulatory i wizualizacje dostępne w aplikacji THE MONEY CLUB — 92 DAYS CHALLENGE
          mają charakter wyłącznie edukacyjny i informacyjny. Nie stanowią one porady inwestycyjnej, rekomendacji ani
          zachęty do zawierania jakichkolwiek transakcji.
        </p>
        <p className="text-white font-semibold text-base">2. Ryzyko</p>
        <p>
          Trading na rynkach finansowych, w szczególności z wykorzystaniem dźwigni finansowej, wiąże się z wysokim
          ryzykiem utraty części lub całości zainwestowanego kapitału. Wyniki historyczne nie gwarantują wyników
          przyszłych.
        </p>
        <p className="text-white font-semibold text-base">3. Model matematyczny</p>
        <p>
          Wartości celów ($100,000 oraz $200,000), wymagane wzrosty procentowe (6.34% oraz 7.14% dziennie) i wszelkie
          projekcje oparte są na modelu procentu składanego. Są to wyłącznie założenia matematyczne i nie stanowią
          gwarancji osiągnięcia jakiegokolwiek wyniku.
        </p>
        <p className="text-white font-semibold text-base">4. Odpowiedzialność</p>
        <p>
          Każdy uczestnik podejmuje decyzje samodzielnie i na własną odpowiedzialność. Autorzy i operatorzy aplikacji
          nie ponoszą odpowiedzialności za jakiekolwiek straty finansowe wynikające z decyzji podjętych na podstawie
          korzystania z aplikacji.
        </p>
        <p className="text-white font-semibold text-base">5. Zarządzanie ryzykiem</p>
        <p>
          Aplikacja promuje zdyscyplinowane zarządzanie ryzykiem (RR 1:1, stały plan). Nigdy nie należy „odrabiać”
          strat poprzez zwiększanie wielkości pozycji ani przekraczać zaplanowanego ryzyka.
        </p>
      </div>
    </div>
  );
}
